import StocksInfo from "./Info"
import History from "./History"

export const paths = [
    {
        path: '/stock',
        component: StocksInfo
    },
    {
        path: '/stocks/history',
        component: History
    }
]
export const StocksRouters = {
    icon: "dolly",
    testId: '',
    label: "Estoque",
    tree: [
        {
            icon: "dolly-flatbed",
            testId: '',
            path: "/stock",
            label: 'Informações'
        },
        {
            icon: "dolly-flatbed",
            testId: '',
            path: "/stocks/history",
            label: 'Movimentação'
        }
    ]
}


// WEBPACK FOOTER //
// ./src/views/AppViews/Stocks/routers.js